import React from "react";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import arrow_right_white from "../../../assets/images/icons/arrow_right_white.svg";

export default function Inactive({ campaign }) {
    useEffect(() => {
        if (campaign?.link) {
            setTimeout(function () {
                window.open(campaign.link, "_blank");
            }, 5000);
        }
    });

    return (
        <div>
            <div className="content">
                <h1>Helaas kan je niet meer meedoen</h1>
                <p>Het onderzoek is gesloten. Je kunt daarom niet meer meedoen. Bedankt voor je interesse!</p>

                {campaign?.link && (
                    <p>
                        Over 5 seconden word je automatisch doorgestuurd. Gebeurt dit niet?{" "}
                        <a target="_blank" href={campaign.link} rel="noreferrer">
                            Klik dan hier
                        </a>
                    </p>
                )}
            </div>
            <div className="buttons_container">
                <Link to={"/"} className="btn btn-primary kingkong">
                    <span>Naar het Landelijk Ouderpanel</span>
                    <img src={arrow_right_white} alt="arrow" />
                </Link>
            </div>
        </div>
    );
}
